
import { AuthenticationGuardService } from './modules/shared/services/authentication-guard.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { HttpModule } from '@angular/http';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxSpinnerModule } from "ngx-spinner";
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ToastrModule } from 'ngx-toastr';

import { AppComponent } from './app.component';
import { LoginComponent } from './modules/pages/login/login.component';
import { PasswordRecoveryComponent } from './modules/pages/login/password-recovery/password-recovery.component';
import { ClientsPageComponent } from './modules/pages/clients-page/clients-page.component';
import { UsersPageComponent } from './modules/pages/users-page/users-page.component';
import { SitesPageComponent } from './modules/pages/sites-page/sites-page.component';
import { HomePageComponent } from './modules/pages/home-page/home-page.component';
import { DashboardSitePageComponent } from './modules/pages/dashboards/dashboard-site-page.component';
import { DashboardSiteGrupoGeradorPageComponent } from './modules/pages/dashboards/dashboard-site-grupo-gerador-page/dashboard-site-grupo-gerador-page.component';
import { DashboardSiteGrupoChillerPageComponent } from './modules/pages/dashboards/dashboard-site-grupo-chiller-page/dashboard-site-grupo-chiller-page.component';
import { DashboardSiteGrupoCaldeiraPageComponent } from './modules/pages/dashboards/dashboard-site-grupo-caldeira-page/dashboard-site-grupo-caldeira-page.component';
import { DashboardSiteConcessionariaPageComponent } from './modules/pages/dashboards/dashboard-site-concessionaria-page/dashboard-site-concessionaria-page.component';
import { DashboardSiteGrupoPSPageComponent } from './modules/pages/dashboards/dashboard-site-grupo-ps/dashboard-site-grupo-ps-page.component';
import { DashboardSiteGraficoPageComponent } from './modules/pages/dashboards/dashboard-site-graficos/dashboard-site-graficos-page.component';
import { AuthenticationInterceptor } from './modules/shared/services/authentication.interceptor';
import { ConfirmationDialogComponent } from './modules/shared/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogService } from './modules/shared/confirmation-dialog/confirmation-dialog.service';
//import { BarChartModule } from '@swimlane/ngx-charts';

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PasswordRecoveryComponent,
    ClientsPageComponent,
    UsersPageComponent,
    SitesPageComponent,
    HomePageComponent,
    DashboardSitePageComponent,
    DashboardSiteGrupoGeradorPageComponent,
    DashboardSiteGrupoChillerPageComponent,
    DashboardSiteGrupoCaldeiraPageComponent,
    DashboardSiteConcessionariaPageComponent,
    DashboardSiteGrupoPSPageComponent,
    DashboardSiteGraficoPageComponent,
    ConfirmationDialogComponent
  ],
  imports: [
    NgbModule,
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    NgxSpinnerModule,
    NgxChartsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    RouterModule.forRoot([
      { path: '', component: HomePageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id', component: DashboardSitePageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id/grupo-geradores', component: DashboardSiteGrupoGeradorPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id/grupo-chillers', component: DashboardSiteGrupoChillerPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id/grupo-caldeiras', component: DashboardSiteGrupoCaldeiraPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id/grupo-ps', component: DashboardSiteGrupoPSPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id/graficos', component: DashboardSiteGraficoPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'dashboard/:id/concessionaria/:idConcessionaria', component: DashboardSiteConcessionariaPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'clientes', component: ClientsPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'sites', component: SitesPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'usuarios', component: UsersPageComponent, canActivate: [AuthenticationGuardService] }
      , { path: 'login', component: LoginComponent }
      , { path: 'recuperacao-senha/:token', component: PasswordRecoveryComponent }
      , { path: '**', component: LoginComponent }
    ])
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true
    },
    ConfirmationDialogService
  ],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationDialogComponent]
})
export class AppModule { }
